// Single sessionStorage signal shared by every login flow (magic-link redeem,
// email OTP, password, passkey). Only one login can be in progress at a time,
// so one key suffices.
//
// It survives the route tree's remount when `isAuthorized` flips during
// `dispatch(initCognitoSession())`: after a successful login we navigate to the
// dashboard, but the route guard briefly bounces back through the login/redirect
// screen while the Cognito session hydrates, remounting it. Component state
// resets on remount, so without this cross-mount signal the fresh instance
// flashes a login form (or the "already authenticated" consent screen) for a few
// hundred ms before the dashboard loads.
export const REDIRECT_IN_PROGRESS_KEY = "cognito_redirect_in_progress";

export function markRedirectInProgress(): void {
  sessionStorage.setItem(REDIRECT_IN_PROGRESS_KEY, "1");
}

export function clearRedirectInProgress(): void {
  sessionStorage.removeItem(REDIRECT_IN_PROGRESS_KEY);
}

// A successful login has just stored Cognito tokens in localStorage; their
// presence distinguishes a genuine in-flight redirect from a stale signal left
// behind after logout. Gating on it means a stale flag can neither strand a
// spinner nor short-circuit a fresh login flow. Matches the token check the
// route guard uses (NavigationMenuContainer).
export function hasCognitoTokens(): boolean {
  return Object.keys(localStorage).some((key) => key.startsWith("CognitoIdentityServiceProvider"));
}

// True only when a redirect was flagged AND Cognito tokens exist — i.e. a login
// is genuinely mid-flight, not a leftover flag.
export function isRedirectInProgress(): boolean {
  return sessionStorage.getItem(REDIRECT_IN_PROGRESS_KEY) === "1" && hasCognitoTokens();
}
